import 'codemirror/addon/mode/simple';
import 'codemirror/addon/display/autorefresh';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/php/php';
import 'codemirror/mode/python/python';
import 'codemirror/mode/ruby/ruby';
import 'codemirror/mode/php/php';
import 'codemirror/mode/shell/shell';
import 'codemirror/mode/swift/swift';
import 'codemirror/mode/yaml/yaml';
import 'codemirror-graphql/hint';
import 'codemirror-graphql/lint';
import 'codemirror-graphql/mode';
import 'react-codemirror/mode/hubl';
import { renderRoot } from 'quartz-core/client';
import UIApplication from 'UIComponents/app/UIApplication';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { MDXProvider } from '@mdx-js/react';

// I18n Configuration
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import { initAppTranslations } from 'I18n/init/setup/AppInit';

// Import extra I18n data
import 'I18n/init/data/currency';
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales';

// Rhumb
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';

// Redux

import { Provider } from 'react-redux';
import configureStore from './utils/configureStore';
import { startApp } from './actions/AppActions';

// Configure the router
import { Router } from 'react-router-dom';
import RoutesPublic from './components/RoutesPublic';
import { mdxComponents } from './utils/mdx';
import { initializePublicUsageTracker } from './utils/usage-tracker/index';
import { publicBrowserHistory } from './routing/history';
import { TrackerProvider } from './utils/usage-tracker/TrackerContext';
import devLogger from 'react-utils/devLogger';
import { fetchAllAvailableSpecs } from './actions/FetchSpecsActions';
import { jsx as _jsx } from "react/jsx-runtime";
const client = new DataFetchingClient();
export default class App {
  constructor() {
    // initialize the public usage tracker to set the tracker first
    initializePublicUsageTracker();
    // then, can configure the store that depends on the usage tracker
    this.store = configureStore();
  }

  // Kicks off the app. This is intentionally not in the constructor.
  start() {
    /** Manually-set I18n locale by subdomain. @see https://product.hubteam.com/docs/frontend/docs/i18n/new-i18n-setup.html */
    const manualLocale = window.I18N_MANUAL_LANG;
    try {
      // Override localStorage set by HubSpot's dev tools extension
      localStorage.removeItem('I18N_MANUAL_LANG');
    } catch (e) {
      devLogger.warn({
        message: 'I18N_MANUAL_LANG: Error removing local storage key',
        key: 'localStorage-I18n-lang'
      });
    }
    const I18nPublicProvider = createPublicI18nProvider({
      manuallySetLocale: !!manualLocale
    });
    const langAvailable = initAppTranslations([I18nPublicProvider.register(lang), registerAllData(I18nPublicProvider)]);
    I18nPublicProvider.setLocale({
      locale: manualLocale || 'en-us',
      langEnabled: true
    });
    Promise.all([langAvailable, this.store.dispatch(fetchAllAvailableSpecs())]).then(() => {
      this.store.dispatch(startApp());
      this.startRouter();
    }).catch(console.error);
  }
  startRouter() {
    renderRoot( /*#__PURE__*/_jsx(UIApplication, {
      name: "developer-docs-ui",
      children: /*#__PURE__*/_jsx(Provider, {
        store: this.store,
        children: /*#__PURE__*/_jsx(MDXProvider, {
          components: mdxComponents,
          children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
            client: client,
            children: /*#__PURE__*/_jsx(RhumbProvider, {
              history: historyAdapter(publicBrowserHistory),
              config: rhumbConfig,
              children: /*#__PURE__*/_jsx(TrackerProvider, {
                children: /*#__PURE__*/_jsx(Router, {
                  history: publicBrowserHistory,
                  children: /*#__PURE__*/_jsx(RoutesPublic, {})
                })
              })
            })
          })
        })
      })
    }));
  }
}